import React, { useEffect, useState } from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import { supabase } from '../../supabase';
import Sidebar from '../../components/Sidebar';
import Loading from '../../components/Loading';
import Funnels from './Funnels';
import Leads from './Leads';
import Account from './Account';
import Home from './Home';
import Admin from './admin';

export default function Dashboard() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    supabase.auth.getUser().then(({ data, error }) => {
      if (error || !data.user) {
        navigate('/login');
      } else {
        setUser(data.user);
      }
    });
  }, []);

  if (!user) return <Loading />;

  return (
    <div className="flex   ">
      <Sidebar />
      <main className="ml-64 p-8 w-full">
        <Routes>
          <Route path="/" element={ <Home /> } />
          <Route path="/funnels" element={<Funnels />} />
          <Route path="/leads" element={<Leads />} />
          <Route path="/account" element={<Account />} />
          <Route path="/leads/:id" element={<Leads />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
    </div>
  );
}
